import React from 'react';
import { NavBar } from './NavBar';
import { DECO_COOKIE, HERO_METRICS, OFFER_ANCHOR } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';

/**
 * Hero mobile-first. Prioridad absoluta: promesa, mockup, precio y CTA entran
 * en el primer pantallazo de un celular que llega desde un anuncio.
 * El CTA NO abre el checkout: hace smooth-scroll a la sección de oferta.
 */
export function Hero() {
  return <div id="top" className="relative overflow-hidden bg-ivory" data-id="element-160" data-mp="1285ztvqq06q0">
      <NavBar data-id="element-161" data-mp="xanq434vpngy" />

      {/* Cookie decorativa que entra desde el lateral, fuera del flujo. */}
      <img src={DECO_COOKIE} alt="" aria-hidden loading="lazy" style={{
      ['--drift-rot' as string]: '-8deg'
    }} className="animate-drift pointer-events-none absolute -left-16 top-[42%] hidden h-40 w-40 rounded-full object-cover opacity-90 mix-blend-multiply lg:block" data-id="element-162" data-mp="sb1a5lxo1t4g" />

      <section aria-labelledby="hero-title" className="relative mx-auto flex min-h-[calc(100svh-3.9rem)] w-full max-w-6xl flex-col px-5 pb-5 pt-4 sm:px-8 lg:grid lg:min-h-0 lg:grid-cols-[1.04fr_0.96fr] lg:grid-rows-[auto_auto_auto] lg:gap-x-12 lg:py-16" data-id="element-163" data-mp="3cz5ug9c21vza">
        {/* Promesa */}
        <div className="animate-hero-copy lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-164" data-mp="3o6u7tceeavdz">
          

          <h1 id="hero-title" className="mt-3 font-display text-[2rem] leading-[1.04] text-charcoal sm:text-[3.05rem] sm:leading-[1.02] lg:text-[3.5rem]" data-id="element-165" data-mp="39a36gxl5v9lq">
            100 New York Cookies para{' '}
            <em className="not-italic text-gold-deep" data-id="element-166" data-mp="30gq3t3xaotmg">fabricar y vender</em>
          </h1>

          <p className="mt-3 max-w-xl font-sans text-[0.92rem] leading-relaxed text-charcoal/65 sm:text-[1.05rem] lg:mt-5" data-id="element-167" data-mp="35aas2493698g">
            100 recetas de cookies gigantes, rellenas y premium listas para preparar desde casa.
          </p>
        </div>

        {/* Mockup protagonista, latiendo suavemente. Más compacto en mobile. */}
        <div className="animate-hero-media relative my-2 flex min-h-[130px] flex-1 items-center justify-center sm:my-3 lg:col-start-2 lg:row-span-3 lg:row-start-1 lg:my-0 lg:min-h-0 lg:flex-none lg:self-center" data-id="element-168" data-mp="2hlja05p7n79e">
          {/* Halo cálido que integra el mockup con el fondo crema. */}
          <div className="absolute left-1/2 top-1/2 h-[80%] w-[88%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold-pale/70 blur-2xl" aria-hidden data-id="element-169" data-mp="n98cdkmjmzmb" />
          <div className="mockup-ground absolute bottom-1 left-1/2 h-7 w-[72%] -translate-x-1/2 blur-md sm:h-12" aria-hidden data-id="element-170" data-mp="ddwz76qsa0go" />
          <img src={HERO_IMAGE_URL} alt="Los 2 tomos de 100 New York Cookies rodeados de cookies rellenas de chocolate, dulce de leche, pistacho, red velvet y cookies & cream." width={1300} height={1200} fetchPriority="high" decoding="async" className="animate-breathe relative h-full max-h-[33vh] w-full object-contain drop-shadow-[0_26px_40px_rgba(53,47,50,0.2)] sm:max-h-[44vh] lg:max-h-[600px]" data-id="element-171" data-mp="1b0dts484tzyq" />
        </div>

        {/* CTA principal: scroll interno a la oferta, nunca al checkout.
            El precio no aparece en el hero: se revela en la sección central. */}
        <div className="lg:col-start-1 lg:row-start-2" data-id="element-172" data-mp="1xa44lgt9woko">
          <a href={OFFER_ANCHOR} className="group mt-3 flex min-h-[58px] w-full items-center justify-center gap-2.5 rounded-full bg-[#F47A2A] px-6 py-3.5 text-center font-sans text-[0.86rem] font-bold uppercase tracking-[0.07em] text-white shadow-[0_16px_30px_-12px_rgba(244,122,42,0.55)] transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#DF6A1D] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#F47A2A]/50 sm:text-[0.94rem] lg:mt-5 lg:w-auto lg:px-10" data-id="element-173" data-mp="1x7hvhcqqi10c">
            Quiero hacer estas cookies
            <span className="transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden data-id="element-174" data-mp="2p10fibvrwj5b">
              →
            </span>
          </a>
        </div>

        {/* Métricas: pueden quedar por debajo del fold */}
        <div className="lg:col-start-1 lg:row-start-3 lg:self-start" data-id="element-175" data-mp="uou4pe6sk4dj">
          <dl className="mt-4 grid grid-cols-4 gap-x-2 border-t border-warm pt-3.5 sm:gap-x-4 lg:mt-8 lg:border-y lg:pb-5" data-id="element-176" data-mp="zm2kx98dpyc5">
            {HERO_METRICS.map(metric => <div key={metric.label} className="text-center lg:text-left" data-id="element-177" data-mp="3vi6wugd962rk">
                <dt className="sr-only" data-id="element-178" data-mp="e9jypxg05fth">{metric.label}</dt>
                <dd data-id="element-179" data-mp="e91tibbd3r9f">
                  <span className="block font-display text-[1.3rem] leading-none text-caramel sm:text-[1.9rem] lg:text-[2.2rem]" data-id="element-180" data-mp="e7h9vgql5sqc">
                    {metric.value}
                  </span>
                  <span className="mt-1 block font-sans text-[0.52rem] font-semibold leading-tight text-charcoal-mid sm:text-[0.66rem]" data-id="element-181" data-mp="3hqjz0c3nwm6o">
                    {metric.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      </section>
    </div>;
}